export class Shift {

    constructor(result) {

        this.id = +(result.id);
        this.idCompany = +(result.id_company);
        this.name = result.name;
        this.from = result.from;
        this.to = result.to;

    }

    getRange() {

        return {
            from: this.from,
            to: this.to,
            id: this.id,
            name: this.name
        }

    }

}

class Shifts {

    initialized = false;

    nullShift = new Shift({
        id: 0,
        id_company: 0,
        name: 'all',
        from: '00:00:00',
        to: '24:00:00'
    });

    constructor(result) {

        if (result) {

            this.shifts = result.map(s => {
                return new Shift(s);
            });

            this.initialized = true;
        } else {
            this.shifts = [];
        }

    }

    get() {

        const shifts = [];

        for (let ix in this.shifts) {
            shifts.push(this.shifts[ix]);
        }

        return shifts;

    }

    getAllShifts() {

        // always return a null dummy-shift as disabled together with the configured shifts
        const shifts = [];

        shifts.push(this.nullShift);

        for (let ix in this.shifts) {
            shifts.push(this.shifts[ix]);
        }

        return shifts;

    }

    getNullShift() {

        return this.nullShift;

    }

    getShiftById(id) {

        for (let ix in this.shifts) {
            let s = this.shifts[ix];

            if (String(s.id) === String(id)) return s;
        }

        return null;

    }

}

export default Shifts;